import { Component, HostListener, OnInit, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormControl, FormArray, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { AuthenticationService } from 'src/app/Services/Authentication/authentication.service';
import { User } from 'src/app/Model/User/user.model';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common'
import { UserRole } from 'src/app/Model/Role/user-role.model'
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { toInteger } from '@ng-bootstrap/ng-bootstrap/util/util';
import { TranslateService } from '@ngx-translate/core';
import { NotificationService } from 'src/app/Services/Notification/notification.service';
import { finalize } from 'rxjs/operators';

interface AppNotification {
  id: number; // Replace with actual ID type
  message: string; // Replace with actual message type
  // Add other properties as needed
  expiry_Date: string;
  created_at: string;
  dismissed: Number;
}



@Component({
  selector: 'app-top-nav-bar',
  templateUrl: './top-nav-bar.component.html',
  styleUrls: ['./top-nav-bar.component.css']
})
export class TopNavBarComponent implements OnInit {
  @Output() chattoggle = new EventEmitter<string>();
  @Output() htmldescription = new EventEmitter<string>();

  @Output() sidebarToggle = new EventEmitter<void>();
  isDarkTheme = false;


  d: any = 0
  p: any = 0
  c: any = 0
  totalunread: any = 0;
  direction = "ltr";
  /**@HostListener('window:message',['$event'])
  onMessage(e)
  {
    if(e.origin=="https://ciotchat.dart-it.com"){
      console.log(e);
    var i =e.data;
    const myJSON = JSON.stringify(i);
    var obj = JSON.parse(i);
    //console.log(obj[0]);
    Object.entries(obj).find(([key,value]) => {
     // console.log(value);
      if(key === "totalunread"){
   // console.log(value);
    this.totalunread=value;
      }
      if(key === "d"){
     //   console.log(value);
        this.d=value;
          }
          if(key === "c"){
        //    console.log(value);
            this.c=value;
              }
              if(key === "p"){
             //   console.log(value);
                this.p=value;
                  }        
    });
    this.d=obj.d;
    this.c=obj.c;
    this.p=obj.p;
    if(obj.eventName == "unread-changed"){
             
      if(isNaN(this.totalunread) || this.totalunread == obj.data){
                       console.log("No New Message");

      }
  
else{
  this.totalunread =  obj.data;
  
               console.log("Total Unread Messages: " + this.totalunread );
console.log("Total Direct Messages: " + this.d);
console.log("Total Team Messages: " + this.p);
console.log("Total Channel Messages: " + this.c);

      //p=0;
      //d=0;
      //c=0;
   
  }
  
  }
}
}**/

  showAllNotifications = false;
  unreadCount;
  latestNotification: AppNotification | null = null;
  showPopup = false;
  passwordResetForm: FormGroup;

  currentUser: User;

  username;
  branch;
  role;
  success;
  error;
  loggedInUsername
  loggedInUserBranch;
  loggedInUserFullname;
  loggedInUserId;
  nameInitials;
  notifications: AppNotification[] = [];


  ticketForm: FormGroup;
  submitted = false;
  loading = false;
  ticketId: string;
  files: File[] = [];


  validationMessages = {
    'password': {
      'required': 'Password Name is required',
      'minlength': 'Password should be atleast 6 characters long'
    },
    'confirmPassword': {
      'required': 'Confirm Password is required',
      'mustMatch': ' Password do not match'
    },

  };


  formErrors = {
    'password': '',
    'confirmPassword': '',
    'minlength': ''


  };

  constructor(
    private authenticationService: AuthenticationService,
    private modalService: NgbModal,
    private router: Router,
    private actroute: ActivatedRoute,
    private _authenticationService: AuthenticationService,
    private fb: FormBuilder,
    private _notificationService: NotificationService,
    private translateService: TranslateService,
    private _location: Location) {
    var lang = localStorage.getItem('language');
    if (lang == "ar") {
      this.direction = "rtl";

    };
    this.htmldescription.emit(lang);
    this._authenticationService.currentUser.subscribe(x => this.currentUser = x);
    if (this.currentUser) {
      this.username = this.currentUser.firstName + ' ' + this.currentUser.middleName + ' ' + this.currentUser.lastName;
      this.branch = this.currentUser.branch;
      this.role = this.currentUser.role;
      this.loggedInUserId = this.currentUser.userName;

      const fullName = this.username.split(' ');
      this.nameInitials = fullName.shift().charAt(0) + fullName.pop().charAt(0);
      this.loggedInUserFullname = this.username;
      this.loggedInUserBranch = this.branch
      this.loggedInUserId = this.currentUser.userName;



    }

  }
  ngOnInit(): void {



    // Step 1: Start listening for notifications specific to user and role
    this._notificationService.startListening(this.loggedInUserId, this.role, this.loggedInUserBranch);


    this._notificationService.notification$.subscribe(notification => {
      const incoming = notification as unknown as AppNotification;
      const exists = this.notifications.some(n => n.id === incoming.id);

      if (!exists) {
        this.notifications.push(incoming);
        this.triggerPopup();
        this.latestNotification = incoming;
      }

      this.unreadCount = this.notifications.length;
    });

    // // Step 2: Subscribe to the notification observable
    // this._notificationService.notification$.subscribe(notification => {
    //   // console.log(notification)

    //   if (notification && typeof notification === 'object') {
    //     const exists = this.notifications.some(n => n.id === notification.id);
    //     // console.log(exists);
    //     //console.log(this.notifications.length);
    //     if (!exists) {
    //       this.notifications.push(notification);  // Add the notification if it's not already in the array
    //       this.triggerPopup();
    //       // Show the popup for the latest notification
    //       this.latestNotification = notification;
    //     }
    //     // console.log(this.notifications);


    //     this.unreadCount = this.notifications.length;
    //   } else {
    //     console.error('Expected an object but received:', notification);
    //   }
    // });

    this.passwordResetForm = this.fb.group({
      modalMsg: new FormControl(''),
      userName: new FormControl('', [Validators.required]),
      fullName: new FormControl(''),
      firstName: new FormControl(''),
      middleName: new FormControl(''),
      lastName: new FormControl(''),
      currentStatus: new FormControl(''),
      password: new FormControl('', [Validators.required, Validators.minLength(6)]),
      confirmPassword: new FormControl('', Validators.required),
      actionPerformedBy: new FormControl(this.loggedInUserId)
    }, { validator: MustMatch('password', 'confirmPassword') });

    this.ticketForm = this.fb.group({
      name: ["", Validators.required],
      userId: [this.loggedInUserId, Validators.required],
      email: ['', [Validators.required, Validators.email]],
      issueType: ['', Validators.required],
      priority: ['', Validators.required],
      appointmentId: [''],
      appointmentDate: [''],
      issueDescription: ['', [Validators.required, Validators.minLength(20)]],
      urgentFlag: [false]
    });


  }//End of NgOnIt


  get f() { return this.ticketForm.controls; }

  onFileChange(event: any): void {
    this.files = Array.from(event.target.files);
  }
  toggleSidebar() {
    console.log(this.sidebarToggle);
    this.sidebarToggle.emit();
  }



  toggleTheme() {
    this.isDarkTheme = !this.isDarkTheme;
    document.body.classList.toggle('dark-theme', this.isDarkTheme);
    document.body.classList.toggle('light-theme', !this.isDarkTheme);

    const mainContent = document.querySelector('.main-content');
    const breadcrumbitem = document.querySelector('.breadcrumb-item');
    const card = document.querySelector('.card');
    const sidebarmenu = document.querySelector('.sidebar');


    mainContent.classList.toggle('dark-theme');
    breadcrumbitem.classList.toggle('dark-theme');
    sidebarmenu.classList.toggle('dark-theme');
    //card.classList.toggle('dark-theme');
    //this.themeicon = this.isDarkTheme ? 'sun' : 'moon'; // Update icon
    // this.cdr.detectChanges(); // Trigger change detection
    // this.updateIcons(); // Update icons after theme change

  }
  togglechat() {
    this.chattoggle.emit("true");
  }


  openPasswordResetModal(currentUser, modal) {
    // console.log(currentUser);

    if (currentUser.status == "Active") {
      var finalmessage = "Are you sure you want to change Password?"
      var newStatus = "Completed";

    } else if (currentUser.status == "InActive") {
      var finalmessage = "Are you sure you want to change password as the user is not Active?"
      var newStatus = "Incomplete";
    }

    this.modalService.open(modal, {
      centered: true,
      backdrop: 'static',

    });

    this.passwordResetForm.patchValue({
      modalMsg: finalmessage,
      userName: currentUser.userName,
      fullName: currentUser.firstName + ' ' + currentUser.middleName + ' ' + currentUser.lastName,
      firstName: currentUser.firstName,
      middleName: currentUser.middleName,
      lastName: currentUser.lastName,
      currentStatus: currentUser.status,
    });



    console.log(this.passwordResetForm.value);
  }




  changeLanguage(lang: string) {
    console.log(lang);
    this.translateService.setDefaultLang(lang);
    this.translateService.use(lang);
    localStorage.setItem('language', lang);
    this.htmldescription.emit(lang);


  }

  submitPasswordReset() {
    this.logValidationErrors(this.passwordResetForm);

    this._authenticationService.passwordReset(this.passwordResetForm.value)
      .subscribe(//subscribe to Observable
        response => {
          this.modalService.dismissAll();
          //  console.log('Success!', response);
          this.success = response['SUCCESS'];
          this.passwordResetForm.reset;
          document.getElementById("openSuccessModalButton").click();
        },
        error => {
          this.modalService.dismissAll();
          //    console.error('ERROR!', error);
          this.error = error.error.text;
          document.getElementById("openErrorModalButton").click();
        }
      );
  }


  ngOnDestroy() {
    // Stop listening when the component is destroyed
    this._notificationService.stopListening();
  }

  triggerPopup() {
    this.showPopup = true; // Show the popup with the animation

    // Hide the popup after 3 seconds
    setTimeout(() => {
      this.showPopup = false;
    }, 3000);
  }

  toggleShowAll() {
    //this.showPopup = true; // Show popup by setting showPopup to true
    setTimeout(() => {
      this.showPopup = false; // Hide after 3 seconds
    }, 3000);
    this.showAllNotifications = !this.showAllNotifications
  }

  dismissNotification(notificationId: number, index) {
    this._notificationService.dismissNotification(notificationId).subscribe(() => {
      this.notifications = this.notifications.filter(n => n.id !== notificationId);
    });

    this.notifications.splice(index, 1);
    this.unreadCount = this.notifications.length;
  }




  onTicketSubmit(): void {
    this.submitted = true;

    // Stop if form is invalid
    if (this.ticketForm.invalid) {
      return;
    }

    this.loading = true;

    // Create FormData object to send both form fields and files
    const formData = new FormData();

    // Append form fields
    Object.keys(this.ticketForm.value).forEach(key => {
      formData.append(key, this.ticketForm.value[key]);
    });

    // Append files if any
    this.files.forEach((file, index) => {
      formData.append(`file${index}`, file, file.name);
    });

    // Submit form
    this._notificationService.submitTicket(formData)
      .pipe(
        finalize(() => {

        })
      )
      .subscribe(
        response => {
          this.ticketId = response.ticketId;
          this.loading = false;
          const modalElement = document.getElementById('openTicketSuccessModalButton').click();
          this.resetTicketForm();
        },
        error => {
          console.error('Error submitting ticket:', error);
          alert('An error occurred while submitting your ticket. Please try again.');
        }
      );
  }




  resetTicketForm(): void {
    this.submitted = false;
    this.ticketForm.reset();
    this.files = [];
  }



  openModal(modal) {
    //console.log(apt);


    this.modalService.open(modal, {
      centered: true,
      backdrop: 'static',
      size: 'lg'
    });
  }


  refreshWindow() {
    location.reload();
  }

  logValidationErrors(group: FormGroup): void {
    //get the keys from FormGroup object and checks all the keys
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      //if the key is part of nested FormGroup or any FormGroup then rerun it through the method again to extract formControl
      if (abstractControl instanceof FormGroup) {
        this.logValidationErrors(abstractControl);
      } else {
        //clear any previous error
        this.formErrors[key] = '';
        //check Validation of the formControl
        if (abstractControl && !abstractControl.valid && (abstractControl.touched || abstractControl.dirty)) {
          //if not valid then get the error message of whatever the validation error is from the validationMessage method
          const messages = this.validationMessages[key];
          //for every error in validation get the error key and assign it to the formControl name is formError method
          for (const errorkey in abstractControl.errors) {
            if (errorkey) {
              //     console.log(key);


              this.formErrors[key] += messages[errorkey] + ''
            }
          }
        }
      }

    });
  }




  logout() {
    this.authenticationService.logout(this.loggedInUserId);
    this.router.navigate(['/login']);
  }




  isAdmin() {
    return this.currentUser && this.currentUser.role === UserRole.Administrator;
  }

  isSystemAdmin() {
    return this.currentUser && this.currentUser.role === UserRole.SystemAdministrator;
  }

  backClicked() {
    this._location.back();
  }


}



function MustMatch(controlName: string, matchingControlName: string) {
  return (formGroup: FormGroup) => {
    const control = formGroup.controls[controlName];
    const matchingControl = formGroup.controls[matchingControlName];

    if (matchingControl.errors && !matchingControl.errors.mustMatch) {
      // return if another validator has already found an error on the matchingControl
      return;
    }

    // set error on matchingControl if validation fails
    if (control.value !== matchingControl.value) {
      matchingControl.setErrors({ mustMatch: true });
    } else {
      matchingControl.setErrors(null);
    }
  }
}